import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DeviceInfo } from '../components/analytics/realtime-audience/models/device-info.model';

@Pipe({name: 'deviceInfo'})

export class DeviceInfoPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer, private translate: TranslateService) {}

	transform(deviceInfo: DeviceInfo, type: string = 'osName_str'): SafeHtml {
		let html = '';
		let itemType = '';
		const title = this.generateTitle(deviceInfo, type);

		if (deviceInfo[type]) {
			switch (type) {
				default:
					itemType = this.osIcons(deviceInfo[type]);
					break;
				case 'browserName_str':
					itemType = this.browserIcons(deviceInfo[type]);
					break;
				case 'deviceType_str':
					itemType = this.deviceTypeIcons(deviceInfo[type]);
					break;
				case 'osName_str':
					itemType = this.osIcons(deviceInfo[type]);
					break;
			}
			html += '<i class="fa fa-' + itemType + '" title="' + title + '" aria-hidden="true"></i>';
		}
		return this.sanitizer.bypassSecurityTrustHtml(html);
	}

	deviceTypeIcons(itemType: string): string {
		itemType = itemType.toLowerCase();
		switch (itemType) {
			case 'desktop':
				itemType = 'desktop';
				break;
			case 'smartphone':
				itemType = 'mobile-phone';
				break;
			case 'tablet':
				itemType = 'tablet';
				break;
			case 'smarttv':
				itemType = 'television';
				break;
			default:
				itemType = 'globe';
		}
		return itemType;
	}

	browserIcons(itemType: string): string {
		itemType = itemType.toLowerCase();
		switch (itemType) {
			case 'chrome':
			case 'chromium':
			case 'chrome mobile':
			case 'chrome mobile ios':
				itemType = 'chrome';
				break;
			case 'facebook':
			case 'facebook messenger':
				itemType = 'facebook-square';
				break;
			case 'safari':
			case 'mobile safari':
				itemType = 'safari';
				break;
			case 'firefox':
				itemType = 'firefox';
				break;
			case 'internet explorer':
				itemType = 'internet-explorer';
				break;
			case 'microsoft edge':
			case 'edge':
				itemType = 'edge';
				break;
			case 'samsung browser':
			case 'android browser':
				itemType = 'android';
				break;
			case 'opera':
				itemType = 'opera';
				break;
			case 'pinterest':
				itemType = 'pinterest-p';
				break;
			case 'opera':
				itemType = 'opera';
				break;
			case 'opera':
				itemType = 'opera';
				break;
			default:
				itemType = 'globe';
		}
		return itemType;
	}

	osIcons(itemType: string): string {
		itemType = itemType.toLowerCase();
		if (itemType.indexOf('windows') !== -1) {
			itemType = 'windows';
		} else if (itemType.indexOf('linux') !== -1) {
			itemType = 'linux';
		} else if (itemType.indexOf('blackberry') !== -1) {
			itemType = 'mobile';
		} else if (itemType.indexOf('playstation') !== -1) {
			itemType = 'gamepad';
		}

		switch (itemType) {
			case 'chrome os':
				itemType = 'chrome';
				break;
			case 'ios':
			case 'os x':
				itemType = 'apple';
				break;
			case 'firefox os':
				itemType = 'firefox';
				break;
			case 'nintendo':
				itemType = 'gamepad';
				break;
			case 'windows':
				break;
			case 'blackberry':
				break;
			case 'playstation':
				break;
			case 'android':
				break;
			case 'mocordroid':
				itemType = 'android';
				break;
			case 'fedora':
			case 'ubuntu':
			case 'mint':
			case 'debian':
			case 'linux':
				itemType = 'linux';
				break;
			default:
				itemType = 'globe';
		}
		return itemType;
	}

	generateTitle(deviceInfo: DeviceInfo, type: string = 'osName_str'): string {
		let title = '';
		if (type === 'osName_str') {
			if (deviceInfo.osName_str) {
				title += deviceInfo.osName_str;
			}
		} else {
			if (deviceInfo.deviceType_str) {
				title += this.translate.instant('DEVICE') + ': ' + deviceInfo.deviceType_str;
				title += '\n';
			}
			if (deviceInfo.mobileBrand_str) {
				title += this.translate.instant('BRAND') + ': ' + deviceInfo.mobileBrand_str;
				title += '\n';
			}
			if (deviceInfo.mobileMarketingName_str) {
				title += this.translate.instant('MODEL') + ': ' + deviceInfo.mobileMarketingName_str;
				title += '\n';
			} else if (deviceInfo.mobileModel_str) {
				title += this.translate.instant('MODEL') + ': ' + deviceInfo.mobileModel_str;
				title += '\n';
			}
			if (deviceInfo.osVersion_str) {
				title += this.translate.instant('OS') + ': ' + deviceInfo.osVersion_str;
				title += '\n';
			} else if (deviceInfo.osName_str) {
				title += this.translate.instant('OS') + ': ' + deviceInfo.osName_str;
				title += '\n';
			}
			if (deviceInfo.browserVersion_str) {
				title += this.translate.instant('BROWSER') + ': ' + deviceInfo.browserVersion_str;
				title += '\n';
			} else if (deviceInfo.browserName_str) {
				title += this.translate.instant('BROWSER') + ': ' + deviceInfo.browserName_str;
				title += '\n';
			}
		}
		return title;
	}
}

/*
deviceInfo examples:

browserName_str:"Chrome"
browserVersion_str:"Chrome 66.0.3359.139"
deviceType_str:"Desktop"
osName_str:"Windows"
osVersion_str:"Windows 10"


browserName_str:"Chrome Mobile"
browserVersion_str:"Chrome Mobile 60.0.3112.116"
deviceType_str:"Smartphone"
mobileBrand_str:"Nokia"
mobileMarketingName_str:"3"
mobileModel_str:"3"
mobileTablet_bool:false
osName_str:"Android"
osVersion_str:"Android 7.1.1"


browserName_str:"Mobile Safari"
browserVersion_str:"Mobile Safari"
deviceType_str:"Smartphone"
mobileBrand_str:"Apple"
mobileMarketingName_str:"iPhone"
mobileModel_str:"iPhone"
mobileTablet_bool:false
osName_str:"iOS"
osVersion_str:"iOS 11.3"

*/
